"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.elementFromString = exports.elementsFromString = void 0;
var variables_1 = require("./dom-variables/variables");
var is_string_1 = require("./is-string");
var fragmentRe = /^\s*<(\w+)[^>]*>/, singleTagRe = /^<(\w+)\s*\/?>(?:<\/\1>)?$/;
var containers = {
    '*': variables_1.div,
    tr: variables_1.tbody,
    td: variables_1.tr,
    th: variables_1.tr,
    thead: variables_1.table,
    tbody: variables_1.table,
    tfoot: variables_1.table
};
function elementsFromString(html) {
    if (!is_string_1.isString(html))
        return [];
    html = html.trim();
    if (singleTagRe.test(html))
        return [variables_1.createElement(RegExp.$1)];
    var fragment = fragmentRe.test(html) && RegExp.$1;
    var container = containers[fragment] || containers['*'];
    container.innerHTML = html;
    return container.childNodes;
}
exports.elementsFromString = elementsFromString;
function elementFromString(htmlString) {
    var elements = elementsFromString(htmlString);
    return elements.length > 0 ? elements[0] : null;
}
exports.elementFromString = elementFromString;
//# sourceMappingURL=element-from-string.js.map